import styled from 'styled-components';

export const Container = styled.div`
	> div:not(:last-child) {
		margin-bottom: 25px;
	}
`;
